import type { DeepPartial } from '@luna/utils-ts';

import type {
    RetailOnlyFeatures,
    RetailOnlyShorthandFeatures,
} from '../../types/RetailOnlyFeatures';
import type { MiscellaneousFeatures } from '../../types/MiscellaneousFeatures';

export const features: DeepPartial<RetailOnlyFeatures> = {
    claims: { enabled: true },
};

export const shorthandFeatures: DeepPartial<RetailOnlyShorthandFeatures> = {
    monthGroup: { enabled: false },
};

export const miscellaneous: DeepPartial<MiscellaneousFeatures> = {};
